<template>
  <div class="c-box-doughnut-chart">
    <c-box
      :title="title"
      :loading="loading"
    >
      <div
        v-if="!loading && !hasData"
        class="no-data-wrapper"
      >
        <no-data />
      </div>
      <div class="row no-gutter">
        <div class="col-lg-3 col-md-5">
          <c-legend
            :data="data.map(i => { return { key: i.label } })"
          />
        </div>
        <div class="col-lg-9 col-md-7">
          <c-doughnut-chart
            class="doughnut-chart"
            :chart-data="chartData"
            :options="chartOptions"
          />
        </div>
      </div>
    </c-box>
  </div>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import CDoughnutChart from '../../../../../../../resources/js/components/ui/CDoughnutChart.vue'
import CLegend from './CLegend.vue'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import pastelRainbowColors from '../../mixins/pastelRainbowColors'

export default {
  name: 'CBoxDoughnutChart',
  components: {
    CBox,
    CDoughnutChart,
    CLegend,
    NoData
  },
  mixins: [pastelRainbowColors],
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      chartOptions: {
        legend: {
          display: false
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        plugins: {
          datalabels: {
            display: false
          }
        },
        responsive: true,
        maintainAspectRatio: true
      }
    }
  },
  computed: {
    chartData () {
      return {
        labels: this.data.map(i => i.label),
        datasets: [
          {
            data: this.data.map(i => i.value),
            backgroundColor: this.color
          }
        ]
      }
    },
    color () {
      return this.data.map((item, index) => this.getNextColor(index))
    },
    hasData () {
      return this.data && this.data.length > 0
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../../../resources/css/variables';

.c-box-doughnut-chart {
  .no-data-wrapper {
    margin-bottom: 5px;
    text-align: center;
  }
  // Кастомный стиль для графика
  .doughnut-chart {
    margin: 0 auto 14px;
    padding-left: 10px;
    max-width: 342px;
    max-height: 342px;
    @media all and (max-width: $mdBreakpoint - 1) {
      padding-left: 30px;
    }
    @media (max-width: $xsBreakpoint) {
      width: 100%;
    }
  }
  // Кастомный стиль для группы кнопок справа от графика
  .c-box-button-group {
    padding-left: 15px;
    @media all and (max-width: $smBreakpoint - 1) {
      padding-left: 0;
    }
  }
  // Убирает горизонтальные отступы (margin, padding) у элементов .row и .col-xs-*, .col-sm-*, .col-md-*, .col-lg-*
  .no-gutter {
    margin-right: 0;
    margin-left: 0;

    & > [class *= 'col-'] {
      padding-right: 0;
      padding-left: 0;
    }
  }
  // Убирает горизонтальные отступы (margin, padding) у элементов .row и .col-md-*
  .no-gutter-md {
    @media all and (max-width: $smBreakpoint - 1) {
      margin-right: 0;
      margin-left: 0;
      & > [class *= 'col-md-'] {
        padding-right: 0;
        padding-left: 0;
      }
    }
  }
  // Убирает горизонтальные отступы (margin, padding) у элементов .row и .col-sm-*
  .no-gutter-sm {
    @media all and (max-width: $smBreakpoint - 1) {
      margin-right: 0;
      margin-left: 0;
      & > [class *= 'col-sm-'] {
        padding-right: 0;
        padding-left: 0;
      }
    }
  }
  // Убирает горизонтальные отступы (margin, padding) у элементов .row и .col-xs-*
  .no-gutter-xs {
    @media all and (max-width: $smBreakpoint - 1) {
      margin-right: 0;
      margin-left: 0;
      & > [class *= 'col-xs-'] {
        padding-right: 0;
        padding-left: 0;
      }
    }
  }
}
</style>
